import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Popup } from '@/components/common/Popup';
import {
  CommonPageContainer,
  CommonPageHeader,
  CommonPageScrollableContent,
} from '@/components/common/CommonPageComponents.style';
import { ctxUser } from '@/contexts/UserContext';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import { PasswordChangeFlow } from '../password-change-flow/PasswordChangeFlow';

export default function PasswordChangePopup({ closePopup }: { closePopup: () => Promise<void> }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userContext = useContext(ctxUser);

  if (!userContext) {
    return null;
  }

  const { user, logout } = userContext;

  function handleFinished() {
    void navigate('/', { replace: true });
    logout();
  }

  const isPhone = isPhoneOrHighScreen();
  const title = t('login.passwordChangeV3.title');
  const body = (
    <CommonPageScrollableContent>
      <PasswordChangeFlow username={user.name} isPhone={isPhone} onFinished={handleFinished} />
    </CommonPageScrollableContent>
  );

  if (isPhone) {
    return (
      <Popup
        popupTitle={title}
        header={undefined}
        body={body}
        footer={undefined}
        closePopup={closePopup}
        isFullScr={true}
        showCloseButton={true}
        leftText={true}
      />
    );
  }

  return (
    <CommonPageContainer data-qa-element-id="password_change_view">
      <CommonPageHeader data-qa-element-id="password_change_view_title">{title}</CommonPageHeader>
      {body}
    </CommonPageContainer>
  );
}
